import type { SocketEventListener } from '@/shared/api';
import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';

const sidebarRealtimeListeners: SocketEventListener[] = [
  {
    event: 'notification',
    handler: (msg: any) => {
      console.log('socket io - notificationListener', msg);
      emitter.emit(EMITTER_CONSTANTS.NOTIFICATION, msg);
    },
  },
];

export default sidebarRealtimeListeners;
